var LOCALES = {
  EN_US: 'en_US',
  FR_CA: 'fr_CA',
  EN_CA: 'en_CA'
};
export default LOCALES;